import { Hotel } from "./hotel.model";

export class Usuario {
  usuario_ID: number = 0;
  nombre_Usuario: string = '';
  apellido_Paterno: string = '';
  apellido_Materno: string = '';
  nombre: string = '';
  carrier_ID: number = 0;
  tel: string = '';
  email: string = '';
  password?: string;
  status?: any;
  selected?: boolean;
  hoteles?: Hotel[];
  rol_ID?: number;
  area_ID?: number;
  rol?: any;
  perfil?: any;
  fecha_Creacion?: any;
  url?: any;

  constructor() {}
}
